import {ValidationItemModel} from './index';

export class ValueDataResponseModel {
    result: any;
    isSuccess: boolean;
    affectedRecords: number;
    endUserMessage: string;
    validationErrors: ValidationItemModel [];
}
